export const SignupStatus = {
    active: true,
    pending: false
};
